var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreentick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.8182 143.636C111.482 143.636 143.636 111.482 143.636 71.8182C143.636 32.1541 111.482 0 71.8182 0C32.1541 0 0 32.1541 0 71.8182C0 111.482 32.1541 143.636 71.8182 143.636Z",
    fill: "#A4CF5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0913 96.7269C58.9095 96.7269 58.7276 96.7269 58.364 96.7269C57.0913 96.545 56.1822 95.8178 55.4549 94.7269L39.2731 67.4541C38.1822 65.4541 38.7276 62.9087 40.7276 61.8178C42.7276 60.7269 45.2731 61.2723 46.364 63.2723L60.0004 86.3632L101.091 50.3632C102.728 48.9087 105.455 49.0905 106.909 50.7269C108.364 52.3632 108.182 55.0905 106.546 56.545L61.8185 95.8178C60.9095 96.3632 60.0004 96.7269 59.0913 96.7269Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/greentick.f6d85dcef152af8dee4afc4251f26437.svg";
export { ForwardRef as ReactComponent };